import api from './api';

const accountSsoService = {
    getProviders: async (accountId) => {
        const response = await api.get(`/account-sso?accountId=${accountId}`);
        return response.data;
    },

    saveProvider: async (data) => {
        const response = await api.post('/account-sso', data);
        return response.data;
    },

    configureProvider: async (id) => {
        const response = await api.post(`/account-sso/${id}/configure`);
        return response.data;
    },

    deleteProvider: async (id) => {
        const response = await api.delete(`/account-sso/${id}`);
        return response.data;
    },
};

export default accountSsoService;
